import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import { PARAGRAPH_TOGGLE, ParagraphToggleOptions } from './types';
import { isNil } from 'lodash';
import React from 'react';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const ReadOnlyParagraphToggleElement = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import('./ReadOnlyParagraphToggleElement').then((mod) => mod.ReadOnlyParagraphToggleElement)
  )
);

export const renderElementParagraphToggle = (options?: any) => (props) => {
  const { element } = props;

  if (element.type === PARAGRAPH_TOGGLE && isNil(element.parentNodeType)) {
    // eslint-disable-next-line no-console
    console.error(
      '[DOL Editor] [ParagraphToggleElement] required `parentNodeType` property',
      element
    );
    return <ReadOnlyParagraphToggleElement {...props} />;
  }

  // return undefined here means aother plugins which use this plugin as a child will customize how it be looked
  return undefined;
};

export const ParagraphToggleReadOnlyPlugin = (options?: ParagraphToggleOptions): SlatePlugin => ({
  renderElement: renderElementParagraphToggle(options),
});
